import { createContext, useContext } from "react";
import type { ComponentType, ReactNode } from "react";

export type OverlayProps = {
  open: boolean;
  children: ReactNode;
  size?: "dialog" | "media" | "fullscreen";
  onClose?: () => void;
  closeLabel?: string;
  closeTestId?: string;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  testId?: string;
};

export const OverlayContext = createContext<ComponentType<OverlayProps> | null>(
  null,
);

export const OverlaySlot = (props: OverlayProps) => {
  const Overlay = useContext(OverlayContext);
  if (!Overlay) throw new Error("OverlaySlot requires a host overlay provider");
  return <Overlay {...props} />;
};
